<template>
    <div class="position-relative">
        <transition name="vue-table-loader">
	        <div class="vue-table-loader" v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>
        <div class="row">
            <div class="col-md-4">
                <base-filter-bar placeholder="Search API Keys"></base-filter-bar>
            </div>
            <div class="col-md-8">
                <base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
            </div>
        </div>
        <div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
            <vuetable ref="vuetable"
                :api-url="grid"
                :fields="fields"
                :css="css.table"
                :per-page="perPage"
				        :append-params="moreParams"
                data-path="data"
                pagination-path=""
                noDataTemplate="No API Keys Found"
				        @vuetable:pagination-data="onPaginationData"
                @vuetable:loaded="onLoaded"
            >
                <template slot="expires_at" slot-scope="props">
                  <template v-if="props.rowData.is_infinity">
                    &infin;
                  </template>
                  <template v-else>
                    {{props.rowData.expires_at}}
                  </template>

                </template>
                <template slot="actions" slot-scope="props">
                    <div class="btn-group">
                        <div class="action-container clearfix">
                            <transition v-bind:name="confirmDelete.transitionValue">
                                <div v-if="confirmDelete.id == props.rowData.id" class="btn-group btn-confirm-delete">
                                    <button @click="deleteToken(props.rowData.id)" class="btn btn-danger"><span>Confirm</span></button>
                                    <div class="btn btn-outline-danger" @click="cancelDeletion()"><i style="color: #AB5755 !important;" class="fa fa-times"></i></div>
                                </div>
                                <button class="btn btn-danger btn-start-confirmation" @click="confirmDeletion(props.rowData.id)" v-if="confirmDelete.id != props.rowData.id"> <span>Revoke</span></button>
                            </transition>
                        </div>
                    </div>
                </template>
            </vuetable>
            <div class="row">
                <div class="col-md-6">
                    <base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
                </div>
                <div class="col-md-6">
                    <base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
                </div>
            </div>
        </div>
        <div class="modal fade" id="view_token_modal_vue" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">My API Key</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <p class="modal-copy">API Key</p>
                            <div class="input-group">
                                <textarea class="form-control" name="name" id="api_key_vue" placeholder="" v-model="viewTokenModal.id" aria-label=""></textarea>
                                <div class="input-group-append" @click="copyToClipboard()">
                                    <span class="input-group-text" style="cursor: pointer;">
                                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

var base_url = window.location.protocol + "//" + window.location.host

import Vue from 'vue';
import VueEvents from 'vue-events';
import axios from 'axios';
import * as Vuetable from 'vuetable-2';
import moment from 'moment';
import BaseFilterBar from './base-filter-bar.vue';
import BasePagination from './base-pagination.vue';
import BasePaginationInfo from './base-pagination-info.vue';
import BaseSelectVisible from './base-select-visible.vue';

Vue.use(VueEvents)

export default {
    name: 'api-keys-listing',
    props: [],
    components: {
        'base-filter-bar': BaseFilterBar,
        'base-pagination': BasePagination,
        'base-pagination-info': BasePaginationInfo,
        'base-select-visible': BaseSelectVisible,
    },
    data() {
        return {
            loading: true,
            perPage: 10,
            moreParams: {},
            fields: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'user.name',
                    title: 'User',
                },
                {
                    name: 'created_at',
                    title: 'Date Created',
                },
                {
                    name: '__slot:expires_at',
                    title: 'Expiry Date',
                },
                {
                    name: '__slot:actions',
                    titleClass: 'actions-single-column',
                }

            ],
            amountsShown: [
                { text: '10', value: 10 },
                { text: '25', value: 25 },
                { text: '50', value: 50 },
                { text: '100', value: 100 }
			],
            grid: base_url + "/pimapi/apikeys",
            css: {
                table: {
                    tableClass: 'table table-striped table-bordered table-middle',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    infoClass: '',
                },
            },
            confirmDelete: {
                id: null,
                transitionValue: 'slide',
                isActive: false
            },
            viewTokenModal : {
                id: null
            }
        }
    },
    mounted() {
        this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
        this.$events.$on('filter-reset', e => this.onFilterReset())
    },
    watch: {
        'perPage' (val, oldVal) {
		    this.$nextTick(function() {
		        this.$refs.vuetable.refresh()
		    })
		},
    },
    methods: {
        onLoaded: function () {
            this.loading = false;
        },
        confirmDeletion(id) {
            if(this.confirmDelete.isActive == true) {
                this.cancelDeletion();
            } else {
                this.confirmDelete.isActive = true;
                this.confirmDelete.id = id;
                this.confirmDelete.transitionValue = 'slide-reverse';
            }
        },
        cancelDeletion() {
            this.confirmDelete.isActive = 'false';
            this.confirmDelete.transitionValue = 'slide';
            this.confirmDelete.id = null;
        },
        deleteToken(id) {
            this.loading = true;
            axios.delete(base_url + '/pimapi/apikeys/' + id, {

            }).then(function(response) {
                this.loading = false;
                this.$refs.vuetable.reload();
            }.bind(this))
            .catch(function(error) {
                console.log(error);
            }.bind(this));
        },
        viewToken(id) {
            this.viewTokenModal.id = id;
            $('#view_token_modal_vue').modal('toggle');
        },
        copyToClipboard() {
            let copyText = document.getElementById('api_key_vue');
            copyText.select();
            document.execCommand('copy');
        },
        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
            this.$refs.vuetable.changePage(page)
        },
        editRow(rowData){
            console.log(rowData);
        },
        doVisibleSet (perPageValue) {
            this.perPage = perPageValue;
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterSet (filterText) {
              this.moreParams = {
                  'filter': filterText
              }
              Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterReset () {
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
    }
}
</script>

<style scoped lang="scss">
.btn-confirm-delete{
	.btn{
		padding: 11px 7px 9px 7px;
		&:last-child{
			z-index: 10;
			}
		}
	}
	.action-container{
		position: relative;
		overflow: hidden;
		height: 38px;
		width: 88px;
		border-radius: 2px;
		.btn-confirm-delete, .btn-start-confirmation{
			position: absolute;
			top: 0;
		}
	}
	.slide-reverse-leave-active,
	.slide-reverse-enter-active,
	.slide-leave-active,
	.slide-enter-active {
	    transition: 0.4s;
	}
	.slide-enter {
	    transform: translate(-100%, 0);
	    span{
	  	    transition: opacity 0.4s;
	  	    opacity: 1;
	    }
	}
	.slide-leave-to {
		span{
			transition: opacity 0.4s;
			opacity: 0;
		}
	    transform: translate(100%, 0);
	}

	.slide-reverse-enter {
	    transform: translate(100%, 0);
	    span{
	  	    transition: opacity 0.4s;
	  	    opacity: 1;
	    }
	}
	.slide-reverse-leave-to {
		span{
			transition: opacity 0.4s;
			opacity: 0;
		}
	    transform: translate(-100%, 0);
	}

</style>
